import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row g-3" }
const _hoisted_2 = { class: "col-md-4" }
const _hoisted_3 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 1,
  class: "col-md-2 d-flex align-items-end"
}
const _hoisted_6 = { class: "form-check mb-2" }
const _hoisted_7 = {
  key: 2,
  class: "col-md-2 d-flex align-items-end"
}
const _hoisted_8 = { class: "form-check mb-2" }
const _hoisted_9 = {
  key: 3,
  class: "col-md-12"
}
const _hoisted_10 = {
  key: 0,
  class: "alert alert-danger mt-3 mb-0"
}
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownListBibMotivoDispensaMulta = _resolveComponent("DropDownListBibMotivoDispensaMulta")!
  const _component_ModalConsulte = _resolveComponent("ModalConsulte")!

  return (_openBlock(), _createBlock(_component_ModalConsulte, {
    ref: "modalRef",
    "hide-footer": false,
    modalWidth: "700px !important"
  }, {
    header: _withCtx(() => [...(_cache[9] || (_cache[9] = [
      _createElementVNode("h4", { class: "modal-title" }, "Devolução de Empréstimo", -1)
    ]))]),
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            class: "form-label",
            for: "campo-dataDevolucao-970e"
          }, "Data de Devolução", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.dataDevolucao) = $event)),
            type: "date",
            class: "form-control",
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.atualizarMulta && _ctx.atualizarMulta(...args))),
            id: "campo-dataDevolucao-970e"
          }, null, 544), [
            [_vModelText, _ctx.form.dataDevolucao]
          ])
        ]),
        (_ctx.mostrarCamposMulta)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[11] || (_cache[11] = _createElementVNode("label", {
                class: "form-label",
                for: "campo-text-970e"
              }, "Multa", -1)),
              _createElementVNode("input", {
                value: _ctx.form.multa.toFixed(2),
                type: "text",
                class: "form-control",
                readonly: "",
                id: "campo-text-970e"
              }, null, 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        (_ctx.mostrarCamposMulta)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  id: "multaPaga",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.multaPagaMarcada) = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onChangeMultaPaga && _ctx.onChangeMultaPaga(...args)))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.multaPagaMarcada]
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "multaPaga"
                }, "Multa Paga", -1))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.podeDispensarMulta)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  id: "dispensaMulta",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dispensaMultaMarcada) = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onChangeDispensaMulta && _ctx.onChangeDispensaMulta(...args)))
                }, null, 544), [
                  [_vModelCheckbox, _ctx.dispensaMultaMarcada]
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("label", {
                  class: "form-check-label",
                  for: "dispensaMulta"
                }, "Dispensa de Multa", -1))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.mostrarDropDownMotivoDispensa)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createVNode(_component_DropDownListBibMotivoDispensaMulta, {
                modelValue: _ctx.form.bibMotivoDispensaId,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.bibMotivoDispensaId) = $event))
              }, null, 8, ["modelValue"])
            ]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.mensagemErro)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.mensagemErro), 1))
        : _createCommentVNode("", true)
    ]),
    actions: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-light",
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      }, "Cancelar"),
      (_ctx.permissaoTela.alterar)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary",
            disabled: _ctx.salvando,
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
          }, _toDisplayString(_ctx.salvando ? "Salvando..." : "OK"), 9, _hoisted_11))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 512))
}